import './Footer.css'

const Footer = () => {
    return (
        <section className="footer">
            <p className='footer-text'>Token Trace &copy; 2023 <a href="https://www.binance.com/en/terms">Terms of Use</a></p>
        </section>
    );
}
 
export default Footer;